import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';

import image1 from "./images/radio1.jpeg";



const Radio_IFM = () => {
    const mediaItems = [
        {
            type: 'image',
            src: image1
        },
        // YouTube videos in embed format
        {
            type: 'youtube',
            src: 'https://www.youtube.com/embed/kmj_ZRXSoV0'
        },
        {
            type: 'youtube',
            src: 'https://www.youtube.com/embed/FaBAJUwBxtY'
        }
        // Add local video - uncomment and add actual video file
        // {
        //     type: 'video',
        //     src: require('./videos/ifm_interview.mp4')
        // }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">IFM Interview</h2>
        <span className="section__subtitle">Featured Guest</span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🎙️ Invited for a <strong>second interview on Radio IFM</strong> to discuss the latest <strong>AI innovations</strong> transforming key industries. 🚀
                    </p>
                    <p className='redRadio__text'>
                        💡 Shared insights on breakthrough applications of Artificial Intelligence in:
                    </p>
                    <ul className="achievement__list">
                        <li className='redRadio__text'>🏥 <strong>Healthcare</strong> – advancing diagnosis and treatment</li>
                        <li className='redRadio__text'>🎮 <strong>Gaming</strong> – enhancing interactivity and creativity</li>
                        <li className='redRadio__text'>🏆 <strong>Sports</strong> – optimizing performance and strategy</li>
                    </ul>
                    <p className='redRadio__text'>
                        An incredible opportunity to spread knowledge and highlight how AI continues to shape the future across multiple sectors. 🌍✨
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default Radio_IFM;
